import { TranslateService } from "@ngx-translate/core";
import { SignalRService } from "src/app/services/signalr.service";
import { MatDialog } from "@angular/material/dialog";
import { FavService } from "./../../services/fav.service";
import { AccountService } from "./../../services/account.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { CompanyList } from "src/app/models/company-list";
import { environment } from "src/environments/environment";
import { Chart } from "src/assets/js/Chart.bundle.min.js";
import { OrderBuyComponent } from "../order-buy/order-buy.component";
import { ConfigService } from "src/app/services/config.service";
import { UrlConstants } from "src/app/models/urlConstants";

@Component({
  selector: "app-market-grid-view",
  templateUrl: "./market-grid-view.component.html",
  styleUrls: ["./market-grid-view.component.scss"],
})
export class MarketGridViewComponent implements OnInit {
  @ViewChild("myCanvas") canvas: ElementRef;
  chartsIndiv: any;
  companies: CompanyList[] = [];
  optionsForIndiv = {
    bezierCurve: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            display: false,
            beginAtZero: false,
          },
        },
      ],
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  constructor(
    private http: HttpClient,
    private accService: AccountService,
    private favService: FavService,
    private dialog: MatDialog,
    public translate: TranslateService
  ) {
    // signalService.marketChanges.subscribe((res) => {
    //   res.forEach((update) => {
    //     if (this.companies != null) {
    //       let itemIndex = this.companies.findIndex(
    //         (item) => item.SYMBOL_CODE == update.SYMBOL_CODE
    //       );
    //       if (this.companies[itemIndex] != update) {
    //         this.companies[itemIndex] = update;
    //         this.companies[itemIndex].isUpdate = true;
    //       }
    //     }
    //   });
    // });
  }

  ngAfterViewInit() {
    this.favService.favCompanies.subscribe((res) => {
      this.companies = [];
      this.companies = res;

      if (this.companies != null && this.companies.length > 0)
        setTimeout(() => {
          this.fetchGraphs();
        }, 300);
    });
  }

  orderBuy(company, isSell) {
    const dialogRef = this.dialog.open(OrderBuyComponent, {
      disableClose: true,
      panelClass: "order-dialog-container",
      data: { symbol: company.SYMBOL_CODE, type: isSell },
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  setCharts() {
    this.chartsIndiv = document.getElementsByClassName("markets-capital-chart");
    if (this.chartsIndiv.length > 0) {
      let index = 0;
      for (let chart of this.chartsIndiv) {
        let data = this.companies[index].chart;
        let bg = chart.dataset.bg;
        let canvas = chart.querySelector("canvas");
        let ctx = canvas.getContext("2d");

        let border =
          this.companies[index].LAST_CHANGE_PRC > 0 ? "53FF03" : "FF2314";

        var gradient =
          this.companies[index].LAST_CHANGE_PRC > 0
            ? "rgba(38,222,129,.1)"
            : "rgba(255, 35, 19,.1)";

        // gradient.addColorStop(0.1, bg);
        // gradient.addColorStop(1, "transparent");
        let lineChartData = {
          labels: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
          ],
          datasets: [
            {
              backgroundColor: gradient,
              borderColor: "#" + border,
              borderWidth: 2,
              data: data,
              bezierCurve: false,
            },
          ],
        };
        new Chart(ctx, {
          type: "line",
          data: lineChartData,
          options: this.optionsForIndiv,
        });
        index++;
      }
    }
  }

  ngOnInit(): void {}

  removeFav(symbol) {
    //this.favService.removeFav(symbol);
  }

  fetchGraphs() {
    var curDateMonth = new Date();
    var prvDateMonth = new Date(
      curDateMonth.getFullYear(),
      curDateMonth.getMonth() - 2,
      curDateMonth.getDay()
    );

    for (let i = 0; i < this.companies.length; i++)
      this.http
        .post(UrlConstants.feedUrl + "/api/Feed/GetSymbolHistory", {
          SymbolCode: this.companies[i].SYMBOL_CODE,
          Skip: "0",
          Take: "30",
          FromDate: prvDateMonth,
          ToDate: curDateMonth,
        })
        .subscribe((res) => {
          let data: any = res;
          this.companies[i].chart = data.map((obj) => obj.CLOSE_PRICE);
          this.setCharts();
        });
  }
}
